<template>
  <div class="container-fluid table-responsive overflow-auto" style="height: 80vh;">
    <h3 class="text-left text-dark font-weight-bolder my-3">
      LAST VIEWED MEMO
    </h3>

    <table class="table table-sm table-bordered table-hover cell-middle text-left sticky-header">
      <thead>
      <tr>
        <th scope="col" style="width: 3vw">#</th>
        <th scope="col">[Subject]</th>
        <th scope="col" style="width: 13vw; text-align: center">[Date]</th>
      </tr>
      </thead>
      <tbody v-if="loading">
      <tr><td colspan="100%"><base-loader /></td></tr>
      </tbody>
      <tbody v-else>
      <tr v-for="(crewCircularViewed, index) in lastMemoViewedReport" :key="crewCircularViewed.id">
        <td>{{index + 1}}</td>
        <td>
          <div>
            <a role="button"
               data-placement="top" :title="crewCircularViewed.letter_no+': '+crewCircularViewed.subject"
               data-toggle="tooltip" class="text-dark" @click="viewCircularFile(crewCircularViewed.circularId)" >
              {{crewCircularViewed.letter_no}}: {{crewCircularViewed.subject}}
            </a>
          </div>

          <a role="button" class="badge badge-danger mr-2"  @click="viewCircularAttachmentFile(attachment.id)"
                v-if="crewCircularViewed.attachments" v-for="(attachment,index) in crewCircularViewed.attachments">
            <font-awesome-icon icon="file-pdf" class="mr-2"></font-awesome-icon>{{attachment.attachment_name}}
          </a>
        </td>
        <td class="text-center">{{crewCircularViewed.logDate}}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import AppLoading from "@/components/AppLoading";
import {FileService} from "@/service/file.service";
import BaseLoader from "@/components/base/BaseLoader";

export default {
  name: "UserMemoView",

  components: {
    BaseLoader,
    AppLoading
  },

  data() {
    return {
      loading: false
    }
  },
  mounted(){
    $(function(){
      $('[data-toggle="tooltip"]').tooltip();
    });
  },
  methods: {
    ...mapActions([
        'getLastMemoViewedReport',
        'getCircularFile',
        'getCircularAttachmentFile'
    ]),
    async initializeData() {
      this.loading = true;
      await this.getLastMemoViewedReport(this.authUser.ipn || this.authUser.code);
      this.loading = false;
    },
    async viewCircularFile(circular) {
      let response = await this.getCircularFile(circular);
      if (!response.errors) {
        await this.initializeData();
        FileService.viewDocument(response.file, response.file_name)
      }
    },
    async viewCircularAttachmentFile(circular_attachment) {
      let response = await this.getCircularAttachmentFile(circular_attachment);
      if (!response.errors) {
        await this.initializeData();
        FileService.viewDocument(response.file, response.file_name)
      }
    },
  },

  computed: {
    ...mapGetters([
        'lastMemoViewedReport',
        'authUser',
        'isLoading',
    ])
  },

  created() {
    this.initializeData();
  },


}
</script>

<style scoped>
/*For Footer use*/
.container-fluid {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
</style>
